import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Images from '../views/Image.vue'
import Admin from '../views/Admin.vue'
import Testimony from '../views/Testimony.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/image',
    name: 'Images',
    component: Images
  },
  {
    path: '/testimony',
    name: 'Testimony',
    component: Testimony
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
